import { getUserRequestJoyrideSteps } from "./requests";
import { getRolegrpsJoyrideSteps } from "./rolegroups";
import { getRolesJoyrideSteps } from "./roles";
import { getUserJoyrideSteps } from "./users";
import { reportSteps } from "./analytics/Analytics.tsx";
import {homeSteps} from "./home/Home.tsx"
import { getSettingJoyrideSteps } from "./settings/index.js";
export const joyrideStepsRules = [
  {
    match: (path) => path === "/",
    steps: homeSteps,
  },
  {
    match: (path, query) => path.startsWith("/rolegroups"),
    steps: (path, query,activeTab) => getRolegrpsJoyrideSteps(path, query,activeTab),
  },
  {
    match: (path, query,activeTab) => path.startsWith("/users"),
    steps: (path, query,activeTab) => getUserJoyrideSteps(path, query,activeTab),
  },
  {
    match: (path, query,activeTab) => path.startsWith("/requests"),
    steps: (path, query,activeTab) => getUserRequestJoyrideSteps(path, query,activeTab),
  },
  {
    match: (path, query,activeTab) => path.startsWith("/roles"),
    steps: (path, query,activeTab) => getRolesJoyrideSteps(path, query,activeTab),
  },
  {
    match: (path) => path.startsWith("/settings"),
    steps: (path, query,activeTab) => getSettingJoyrideSteps(path),
  },

  {
    match: (path) => path === "/analytics",
    steps: reportSteps,
  },
];
